export const COMBO_TYPE = {
  SEQUENCE: 'S',
  PARALLEL: 'P',
}

export const COMBO_PRICE_TYPE = {
  SERVICE_PRICING: 'S',
  CUSTOM_PRICING: 'C',
}

export const COMBO_VARIANT = 'C'
